import React from 'react';
import Feed from '../components/Feed/Feed';
import WritePostCard from '../components/Feed/WritePostCard';
import Head from '../components/Header/Head';
import Header from '../components/Header/Header';
import withApollo from '../lib/withApollo';

const FeaturedFeed = () => {
  return (
    <>
      <Head
        title="Featured Travel Blogs"
        feedUrl="featured"
        description="Discover travel stories, insider experiences and recommendations created by our large community of travel bloggers. Join our travel community!"
      />
      <Header active="featured" subheader="Featured" />
      <Feed
        active="featured"
        minScore={14000}
        orderby="createdAt"
        WritePostCard={WritePostCard}
      />
    </>
  );
};

export default withApollo(FeaturedFeed);
